import { Environment } from '@at/sauron-platform-core';
function getZendeskChatScriptSrcUrl(env) {
    switch (env) {
        case Environment.dev:
            return 'https://static.zdassets.com/ekr/snippet.js?key=1bdd571f-5527-4484-8332-d7e4736ab47c';
        case Environment.local:
        case Environment.preprod:
            return 'https://static.zdassets.com/ekr/snippet.js?key=4975df12-a9b2-4142-83b7-f1e3606852b8';
        case Environment.prod:
            return 'https://static.zdassets.com/ekr/snippet.js?key=11a1bb35-c812-4673-b6ed-e0c1a4d34a70';
    }
}
export function addZendeskChatScriptToDocument(env) {
    if (document.getElementById('ze-snippet') === null) {
        const zendeskScript = document.createElement('script');
        zendeskScript.id = 'ze-snippet';
        zendeskScript.type = 'text/javascript';
        zendeskScript.src = getZendeskChatScriptSrcUrl(env);
        zendeskScript.defer = true;
        document.body.appendChild(zendeskScript);
    }
}
